import nodata from '@/assets/nodata.png';  // 确保路径正确
const NoData = () => {
    return (
        <div className="lg:w-full h-full flex flex-col justify-center items-center ">
            <img src={nodata} className="w-48 lg:ml-0 ml-8" alt="No Data" />
            <p className="mt-4 text-[#a8a8a8] text-center text-sm">
                Bind your address to participate in the Spin or Mission now.
            </p>
        </div>
    );
};

export default NoData;
